import { withTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useUserShippingAddress } from "@hooks/use-addresses";
import Button from "@components/core/Button";
import Link from "@components/core/Link";

function ShippingAddressValidation({ t }) {
  const router = useRouter();
  const shippingAddress = useUserShippingAddress();

  if (!shippingAddress) {
    return (
      <div className="p-3 bg-white">
        <Link
          href={{
            pathname: "/profile/addresses/shipping",
            query: {
              redirect: router.asPath,
              origin: "closetDrawer",
            },
          }}
        >
          <Button fullWidth>
            {t("common:drawer.modal_rtc.validate.addresses.add_address")}
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column gap-2 p-3 bg-white">
      <div className="d-flex justify-content-between align-items-center">
        <p className="font-weight-bold font-size-sm text-uppercase mb-0">
          {shippingAddress.delivery_mode === "home" ? (
            t("common:drawer.modal_rtc.validate.addresses.shipping_home")
          ) : (
            t("common:drawer.modal_rtc.validate.addresses.shipping_relay")
          )}
        </p>

        <div>
          <Link
            className="link-primary no-underline"
            href={{
              pathname: "/profile/addresses/shipping",
              query: {
                redirect: router.asPath,
                origin: "closetDrawer",
              },
            }}
          >
            {t("common:drawer.modal_rtc.validate.change")}
          </Link>
        </div>
      </div>

      <div>
        <p className="mb-0">
          {shippingAddress.delivery_mode === "home" ? (
            `${shippingAddress.first_name} ${shippingAddress.last_name}`
          ) : (
            shippingAddress.info
          )}
        </p>
        <p className="mb-0">
          {shippingAddress.line1}
        </p>
        {shippingAddress.line2 && (
          <p className="mb-0">
            {shippingAddress.line2}
          </p>
        )}
        <p className="mb-0">
          {`${shippingAddress.zip} ${shippingAddress.city}, ${shippingAddress.country}`}
        </p>
      </div>

      <p className="font-size-xs text-gray mb-0">
        {t("common:drawer.modal_rtc.validate.addresses.preparation_delay", { daysCount: shippingAddress.country === "FR" ? 3 : 4 })}
      </p>
    </div>
  );
}

export default withTranslation("common")(ShippingAddressValidation);
